
import React, { useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useMounted from '../../../hooks/useMounted';

import SimpleReactValidator from 'simple-react-validator';
import { post, get } from '../../../helpers/api_helper';
import { POST_GET_PAYMENT_DETAIL, POST_ADD_EDIT_PAYMENT, GET_EMPLOYEES_LIST } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import Loader from '../../../components/Loader';
import { useTranslation } from 'react-i18next';
import { local_utc_timestamp } from '../../../helpers/Helper';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';


const Payment = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [isLoader, setLoader] = useState(0);

    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [form_inputs, setInputs] = useState({ paymentId: 0, employeeId: '', date: local_utc_timestamp(new Date()), paymentType: '', paymentMethod: '', note: '', amount: '' });
    const [, forceUpdate] = useState();

    const { id } = useParams()

    useMounted(() => {
        async function get_detaile() {
            get_employees();
            if (id) {
                var res_data = await post(POST_GET_PAYMENT_DETAIL, { 'paymentId': id });
                if (res_data.status) {
                    setInputs(res_data.data.detail);
                } else {
                    toast.error(res_data.message);
                    navigate("/dashboard");
                }
            }
            setLoader(1)
        }

        get_detaile();
    }, [navigate])

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_ADD_EDIT_PAYMENT, form_inputs);
            if (res_data.status) {
                toast(res_data.message);
                navigate("/payments");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    const get_employees = async () => {
        var api_res = await get(GET_EMPLOYEES_LIST);
        if (api_res.status) {
            setEmployees(api_res.data.employees.map(employee => ({
                value: employee.employeeId,
                label: `${employee.name} (E-${employee.employeeId})`
              })));
        } else {
            toast.error(api_res.message);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
    }

    const amountFormat = (e) => {
        const value = e.target.value;
        const regex = /^\d*\.?\d*$/;
        if (!regex.test(value)) {
            // Remove invalid character if not matching
            e.target.value = value.slice(0, -1);
        }
    }


    if (!isLoader) {
        return (<Loader />);
    }
    return (
        <>
            <div className='row'>
                <div className="col-md-6">
                    <div className="card mb-4">
                        <h5 className="card-header">{t('payment.form.title')}</h5>
                        <div className="card-body">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('payment.form.date')} *</label>
                                    <DatePicker name='date' className='form-control'
                                        selected={form_inputs.date} onChange={(date) => {
                                            handleInputChange({ target: { name: 'date', value: local_utc_timestamp(date) } })
                                        }}
                                        dateFormat="dd/MM/yyyy"
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                    {simpleValidator.current.message('date', form_inputs.date, 'required', {
                                        messages: {
                                            required: t('payment.formError.date')
                                        }
                                    })}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('payment.form.employee')} *</label>
                                    <Select
                                        name='employeeId'
                                        value={employees.find(emp => emp.value === form_inputs.employeeId) || null}
                                        onChange={(value) => {handleInputChange({target : {name : 'employeeId', value : value.value}})}}
                                        options={employees}
                                    />
                                    {simpleValidator.current.message('name', form_inputs.employeeId, 'required', {
                                        messages: {
                                            required: t('payment.formError.employeeRequired')
                                        }
                                    })}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('payment.form.paymentType')} *</label>
                                    <select name='paymentType' className='form-control' value={form_inputs.paymentType} onChange={handleInputChange}>
                                        <option value="">{t('payment.placeholder.paymentType')}</option>
                                        <option value="Advance">Advance</option>
                                        <option value="Salary">Salary</option>
                                    </select>
                                    {simpleValidator.current.message('name', form_inputs.paymentType, 'required', {
                                        messages: {
                                            required: t('payment.formError.paymentTypeRequired')
                                        }
                                    })}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('payment.form.paymentMethod')} *</label>
                                    <select name='paymentMethod' className='form-control' value={form_inputs.paymentMethod} onChange={handleInputChange}>
                                        <option value="">{t('payment.placeholder.paymentMethod')}</option>
                                        <option value="Cash">Cash</option>
                                        <option value="Cheque">Cheque</option>
                                        <option value="Online">Online</option>
                                    </select>
                                    {simpleValidator.current.message('name', form_inputs.paymentMethod, 'required', {
                                        messages: {
                                            required: t('payment.formError.paymentTypeRequired')
                                        }
                                    })}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('payment.form.amount')} *</label>
                                    <input name="amount" value={form_inputs.amount} onKeyUp={amountFormat} onChange={handleInputChange} className="form-control" placeholder={t('payment.placeholder.amount')} type="text" maxLength={8} />
                                    {simpleValidator.current.message('amount', form_inputs.amount, 'required', {
                                        messages: {
                                            required: t('payment.formError.amountRequired')
                                        }
                                    })}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('payment.form.note')}</label>
                                    <textarea name="note" value={form_inputs.note} onChange={handleInputChange} className="form-control" placeholder={t('payment.placeholder.note')} />
                                </div>

                                <div className='text-center'>
                                    <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                        {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('save')}
                                    </button>
                                    <Link to="/payments" className="btn btn-danger ms-3"> {t('cancel')}</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Payment;